export const isServer = typeof window === 'undefined';

export const jsonParse = (data: string) => {
  try {
    return JSON.parse(data);
  } catch (err) {
    return null;
  }
};

export const wait = (milliseconds:number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export const getClientDateTime = (): string => {
  return new Date().toISOString();
};

